import React, { useContext } from "react";
import { FormContext } from "./Form";
import { Informative } from "../../Inputs/General/Index";
import { RecidueArea } from "./Styles";

export default function Recidue({ value, className = "" }) {
  /**
   * @type {{
   *    document:import("types/typedef/documents").DocumentI
   * }}
   */
  const { document } = useContext(FormContext);

  return (
    <>
      {className !== "" ? (
        <div>
          <Informative
            readonly={true}
            label="Saldo"
            value={!value ? document.amount.residue.text : value}
          />
        </div>
      ) : (
        <RecidueArea>
          <Informative
            readonly={true}
            label="Saldo"
            value={!value ? document.amount.residue.text : value}
          />
        </RecidueArea>
      )}
    </>
  );
}
